import styled from 'styled-components/macro';

export const ScPenWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 43px;
  height: 43px;
  cursor: pointer;
  transform: translateY(125%);
  z-index: 1;
`
